import React, { FC } from 'react';
import { Seo, useSeoDefaults } from '@funtech-int/yango-shared';

import { useI18n } from '@/shared/i18n/seo/useI18n';
import { settingsRoute } from '@/scenarios/settings/routes';

export const SettingsHead: FC = () => {
    const intl = useI18n();
    const { seoSiteName } = useSeoDefaults();

    const location = settingsRoute();
    const title = intl('settings_seo_title', { brandName: seoSiteName });
    const description = intl('settings_meta_description', { brandName: seoSiteName });

    return (
        <>
            <Seo.BasicMeta seoTitle={title} seoDescription={description} location={location} />
            <Seo.OgWebsiteMeta ogTitle={title} ogDescription={description} location={location} />
            <Seo.TwitterMeta twitterDescription={description} />
        </>
    );
};
